import ResizeController from '../../assets/js/controllers/resize';
import Platform from '../../assets/js/constants/platform';
import ScrollController from '../../assets/js/controllers/scroll';
import SkrolliteController from '../../assets/js/controllers/skrollite';

import { getRootOffset, multiAddEventListener, multiRemoveEventListener, querySelectorArray, classesActiveAndIn, classesDelayedOut } from '../../assets/js/helpers';

export default class TabUnderline {

	static selector = '[data-tab-underline]';

	// class variables

	attributes = {};

	config = {};

	controllers = {
		resize: null
	};

	coords = {
		container: {
			width: 0
		}
	};

	el = {};

	flags = {
		isFocused: false,
		isMouseOver: false
	};

	selectors = {
		// elements
		mask: '[data-tab-underline-mask]', // (optional) will default to container
		handle: '[data-tab-underline-handle]',
		items: '[data-tab-underline-item]',
		itemsInner: '[data-tab-underline-item-inner]'
	};

	states = {
		activeItem: null,
		focusItem: null,
		pageItem: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,

			// singles
			mask: container.querySelector(this.selectors.mask) || container,

			// multiples
			handles: container.querySelectorAll(this.selectors.handle),
			items: container.querySelectorAll(this.selectors.items),
			inputs: container.querySelectorAll(`${this.selectors.items} input`)
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
		this.measureResize();
		this.adjustResize();
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.inputs, 'focus', this.#onInputFocus);
		multiAddEventListener(this.el.inputs, 'blur', this.#onInputBlur);
		multiAddEventListener(this.el.items, 'click', this.#onItemClick);
		multiAddEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		multiAddEventListener(this.el.items, 'mouseleave', this.#onItemOut);

		this.el.container.addEventListener('mouseleave', this.#onContainerLeave);

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.inputs, 'focus', this.#onInputFocus);
		multiRemoveEventListener(this.el.inputs, 'blur', this.#onInputBlur);
		multiRemoveEventListener(this.el.items, 'click', this.#onItemClick);
		multiRemoveEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		multiRemoveEventListener(this.el.items, 'mouseleave', this.#onItemOut);

		this.el.container.removeEventListener('mouseleave', this.#onContainerLeave);

		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onInputFocus = (e) => {
		const $target = e.currentTarget;
		const $item = $target.closest(this.selectors.items);
		this.states.activeItem = $item;
		this.states.focusItem = $item;
		this.flags.isFocused = true;
		this.changeActiveItem(this.states.activeItem);
	};

	#onInputBlur = (e) => {
		const $target = e.currentTarget;
		const $item = $target.closest(this.selectors.items);
		this.flags.isFocused = false;
		this.states.focusItem = null;

		if (this.states.activeItem === $item) {
			this.states.activeItem = null;
			this.changeActiveItem(this.states.pageItem, false);
		}
	};

	#onItemClick = (e) => {
		const $target = e.currentTarget;
		this.states.activeItem = $target;
		this.states.focusItem = $target;

		// Added this for "single page" tabs
		if ($target.hasAttribute('data-tabs-nav-id') && $target.hasAttribute('data-tabs-id')) {
			this.states.pageItem = $target;

			const sibs = $target.parentNode.children;
			const thisTabId = $target.getAttribute('data-tabs-nav-id');
			for (let i = sibs.length - 1; i >= 0; i--) {
				classesDelayedOut(sibs[i]);
			}
			const contentTabs = document.querySelectorAll('.grid-tabbed__tab-content');
			for (let i = contentTabs.length - 1; i >= 0; i--) {
				if (contentTabs[i].getAttribute('data-tabs-content-id') === thisTabId) {
					classesActiveAndIn(contentTabs[i]);
				} else {
					classesDelayedOut(contentTabs[i]);
				}
			}
			window.history.replaceState(null, null, `?category=${$target.getAttribute('data-tabs-id')}`);
			classesActiveAndIn($target);

			// Refresh Skrollite/Stickies/etc.
			ScrollController.refresh();
			ScrollController.updateChildren();
			ScrollController.gatherStickies();
			ScrollController.updateStickies();
			SkrolliteController.pageUpdate();
		}

		if ($target.hasAttribute('data-tab-filter-item')) {
			this.states.pageItem = $target;

			const sibs = $target.parentNode.children;
			for (let i = sibs.length - 1; i >= 0; i--) {
				classesDelayedOut(sibs[i]);
			}

			classesActiveAndIn($target);

			// Refresh Skrollite/Stickies/etc.
			ScrollController.refresh();
			ScrollController.updateChildren();
			ScrollController.gatherStickies();
			ScrollController.updateStickies();
			SkrolliteController.pageUpdate();
		}

		this.changeActiveItem(this.states.activeItem);
	}

	#onItemOver = (e) => {
		if (ResizeController.platform === Platform.DESKTOP) {
			const $target = e.currentTarget;
			this.flags.isMouseOver = true;

			if (this.flags.isFocused) {
				// this.states.activeItem = $target;
				// this.changeActiveItem(this.states.activeItem);
			} else {
				this.states.activeItem = $target;
				this.changeActiveItem(this.states.activeItem);
			}
		}
	};

	#onItemOut = () => {
		if (ResizeController.platform === Platform.DESKTOP) {
			this.flags.isMouseOver = false;
		}
	};

	#onContainerLeave = () => {
		if (this.flags.isFocused) {
			this.changeActiveItem(this.states.focusItem);
		} else {
			this.changeActiveItem(this.states.pageItem);
		}
	};

	// controller methods

	#onResizeUpdate = () => this.measureResize();
	#onResizeRender = () => {
		this.adjustResize();
	}

	//

	measureResize() {
		this.coords.container.width = this.el.container.offsetWidth;

		if (ResizeController.platform === Platform.MOBILE) {
			this.flags.isMouseOver = false;
		}

		return true;
	}

	adjustResize() {
		for (let i = 0; i < this.el.handles.length; i++) {
			const $handle = this.el.handles[i];
			$handle.style.transformOrigin = '0% 50%';
		}

		this.checkActiveItem();
	}

	//

	changeActiveItem($item) {
		if ($item) {
			const $itemInner = $item.querySelector(this.selectors.itemsInner);
			const nextItemLeft = getRootOffset($item, this.el.mask).left;
			const nextItemWidth = $itemInner ? $itemInner.offsetWidth : $item.offsetWidth;
			const nextItemStylesComputed = getComputedStyle($item);

			let handleBgColor = '#2A2A2D';

			if ($item === this.states.pageItem) {
				handleBgColor = '#FF3333';
			}

			// special need for modules/split-routing/tab to compensate for extra scroll snapping space
			const nextItemCrop = ResizeController.platform === Platform.MOBILE ? parseInt($item.getAttribute('data-tab-underline-item-crop-mobile')) || 0 : 0;
			const itemMargin = parseInt(nextItemStylesComputed.marginLeft);

			// calculate handle x and width
			const handleX = nextItemLeft - itemMargin;
			const handleScaleX = (nextItemWidth + itemMargin * 2 - nextItemCrop) / this.coords.container.width;

			for (let i = 0; i < this.el.handles.length; i++) {
				const $handle = this.el.handles[i];
				$handle.style.background = handleBgColor;
				$handle.style.transform = `translateX(${handleX}px) scaleX(${handleScaleX})`;
			}

			if (ResizeController.platform === Platform.MOBILE) {
				this.el.mask.scroll({ top: 0, left: $item.offsetLeft, behavior: 'smooth' });
			}
		}
	}

	changePageItem($item) {
		this.states.pageItem = $item;
		this.changeActiveItem($item, true);
	}

	checkActiveItem() {
		const $pageItem = querySelectorArray(this.el.items, '.is-active', true);
		this.changePageItem($pageItem);
	}

	//

	enable() {
		this.flags.isEnabled = true;
	}

	disable() {
		this.flags.isEnabled = false;
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
